const AVCTheme = {
  space: {
    "6xs": "2px",
    "5xs": "4px",
    "4xs": "8px",
    "3xs": "12px",
    "2xs": "16px",
    xs: "24px",
    sm: "32px",
    md: "40px",
    lg: "48px",
    xl: "56px",
    xxl: "64px",
  },
  padding: {
    p1: "4px",
    p2: "8px",
    p3: "12px",
    p4: "16px",
    p5: "24px",
    p6: "32px",
    p7: "48px",
  },
  fontSize: {
    "3xs": "9px",
    "2xs": "10px",
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "18px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "32px",
    "4xl": "48px",
    "5xl": "56px",
    "6xl": "64px",
    "7xl": "72px",
  },
  fontWeight: {
    normal: "400",
    bold: "600",
  },
  width: {
    xs: "24px",
    sm: "32px",
    md: "40px",
    lg: "48px",
    xl: "56px",
    xxl: "64px",
  },
  height: {
    xs: "24px",
    sm: "32px",
    md: "40px",
    lg: "48px",
    xl: "56px",
    xxl: "64px",
  },
  border: {
    default: "1px solid",
    interactive: "2px solid",
  },
  borderRadius: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    rounded: "999px",
  },
};

export default AVCTheme;
